/* eslint no-useless-escape: "off" */
import _ from 'lodash';
import moment from 'moment';

function getTime(time) {
	return moment(time).format('HH:mm');
}

function getDate(time) {
	const year = moment(time).format('YYYY');
	const currentYear = moment().format('YYYY');
	if (year === currentYear) {
		return moment(time).format('DD MMM').toUpperCase();
	}
	return moment(time).format('DD MMM YYYY').toUpperCase();
}

function getDateTime(time) {
	const year = moment(time).format('YYYY');
	const currentYear = moment().format('YYYY');
	if (year === currentYear) {
		return moment(time).format('DD MMM HH:mm').toUpperCase();
	}
	return moment(time).format('HH:mm:ss DD MMM YYYY').toUpperCase();
}


function prettyDateTime(dateTime) {
	return moment(dateTime).format('DD/MM/YYYY');
}

function prettyShortNumeral(totalAmount) {
	if (!totalAmount) {
		return '0';
	}

	let unit = '';
	let parsedNumber = totalAmount;

	if (totalAmount > 1000000) {
		unit = 'M';
		parsedNumber = totalAmount / 1000000;
	} else if (totalAmount > 1000) {
		unit = 'k';
		parsedNumber = totalAmount / 1000;
	}

	if (parsedNumber < 10) {
		return parsedNumber.toFixed(2) + unit;
	}
	return parsedNumber.toFixed(1) + unit;
}

function getError(error, key) {
	return _.get(error, key) || '';
}

function parseErrors(errorResponse) {
	const errors = {};
	_.mapKeys(errorResponse, (value, key) => {
		_.set(errors, key, value);
	});
	return errors;
}

function resetStatusMessage() {
	return {
		error: null,
		isSaved: false,
		isSaving: false,
    payload: null,
	};
}

function isValidURL(url) {
	const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	return regexp.test(url);
}

export {
	getDate,
	getTime,
	getDateTime,
	prettyDateTime,
	getError,
	parseErrors,
	prettyShortNumeral,
	isValidURL,
	resetStatusMessage,
};



// WEBPACK FOOTER //
// ./src/modules/utilities.js